export default __webpack_public_path__ + "static/media/no-content.290eb15b.png";